import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Register
	$("form[name='register']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'register[password]': {
				required: true,
			},
			'register[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
		},
		messages: {
			'register[password]': {
				required: window.translations.required,
			},
			'register[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
